import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "../components/ui/Button";
import ProductDetailPopup from "./ProductDetailPopup";
import RequestQuotationModal from "./RequestQuotationModal";

// Import all possible category images
import { herobg1, herobg2, herobg3, herobg4 } from "./index";

// const categoryData = {
//   "dehydrated-products": {
//     title: "DEHYDRATED PRODUCTS",
//     image: herobg3,
//     products: [
//       {
//         id: "P001",
//         image: require("../assets/collection2.png"),
//         name: "Dehydrated Fried Onions Red/White",
//         category: "Dehydrated",
//         description: "Pure dehydrated garlic powder with intense flavor",
//         hexCode: "25585DF53",
//       },
//       {
//         id: "P002",
//         image: require("../assets/collection2.png"),
//         name: "Dehydrated Fried coated Onions Red/ white",
//         category: "Dehydrated",
//         description: "Pure dehydrated garlic powder with intense flavor",
//         hexCode: "25585DF53",
//       },
//       {
//         id: "P003",
//         image: require("../assets/collection2.png"),
//         name: "Red Onion Powder",
//         category: "Dehydrated",
//         description: "Pure dehydrated garlic powder with intense flavor",
//         hexCode: "25585DF53",
//       },
//       {
//         id: "P004",
//         image: require("../assets/collection2.png"),
//         name: "White Onion Powder",
//         category: "Dehydrated",
//         description: "Pure dehydrated garlic powder with intense flavor",
//         hexCode: "25585DF53",
//       },
//       {
//         id: "P006",
//         image: require("../assets/collection2.png"),
//         name: "Red and white onion Flakes",
//         category: "Dehydrated",
//         description: "Pure dehydrated garlic powder with intense flavor",
//         hexCode: "25585DF53",
//       },
//     ]
//   },
//   "turmeric-powder": {
//     title: "TURMERIC POWDER",
//     image: herobg4,
//     products: [
//       {
//         id: "P003",
//         image: require("../assets/collection3.png"),
//         name: "Organic Turmeric Powder",
//         category: "Turmeric",
//         description: "100% organic turmeric powder with high curcumin content",
//         hexCode: "25585DF54",
//       },
//       // Add more turmeric products...
//     ]
//   },
//   "chilly-powder": {
//     title: "CHILLY POWDER",
//     image: herobg2, // You can use a different image
//     products: [
//       {
//         id: "P301",
//         image: require("../assets/collection3.png"),
//         name: "Red chilli powder",
//         category: "Chilly",
//         description: "Hot and flavorful red chilly powder",
//         hexCode: "25585DF55",
//       },
//       {
//         id: "P302",
//         image: require("../assets/collection3.png"),
//         name: "Byadgi Mirchi Powder",
//         category: "Chilly",
//         description: "Hot and flavorful red chilly powder",
//         hexCode: "25585DF55",
//       },
//       {
//         id: "P303",
//         image: require("../assets/collection3.png"),
//         name: "Garam Masala",
//         category: "Chilly",
//         description: "Hot and flavorful red chilly powder",
//         hexCode: "25585DF55",
//       },
//       {
//         id: "P304",
//         image: require("../assets/collection3.png"),
//         name: "Dhaniya Powder",
//         category: "Chilly",
//         description: "Hot and flavorful red chilly powder",
//         hexCode: "25585DF55",
//       },
//       // Add more chilly products...
//     ]
//   }
// };

const categoryData = {
  "dehydrated-products": {
    title: "DEHYDRATED PRODUCTS",
    image: herobg3,
    products: [
      {
        id: "P001",
        image: require("../assets/dRed.jpeg"), // Suggested: crispy red & white fried onions in a bowl
        name: "Dehydrated Fried Onions Red",
        category: "Dehydrated",
        description: "Crunchy, flavor-packed fried onions made from red onion varieties, ideal for garnishing and seasoning.",
        hexCode: "25585DF53",
      },
      
      {
        id: "P002",
        image: require("../assets/white.jpeg"), // Suggested: coated onion rings close-up
        name: "Dehydrated Fried Coated Onions White",
        category: "Dehydrated",
        description: "Deep-fried coated white onion slices with a crisp outer layer, perfect for snacks or toppings.",
        hexCode: "25585DF53",
      },
      {
        id: "P003",
        image: require("../assets/red_o_powder.png"), // Suggested: red onion powder in spoon or bowl
        name: "Red Onion Powder",
        category: "Dehydrated",
        description: "Finely ground powder made from dried red onions, rich in flavor and aroma for everyday cooking.",
        hexCode: "25585DF53",
      },
      {
        id: "P004",
        image: require("../assets/white_onion_powder.png"), // Suggested: white powder in spice jar
        name: "White Onion Powder",
        category: "Dehydrated",
        description: "Smooth, light-colored powder from dried white onions, great for soups, sauces, and seasoning.",
        hexCode: "25585DF53",
      },
      {
        id: "P006",
        image: require("../assets/flakes.jpeg"), // Suggested: colorful red and white onion flakes on a wooden plate
        name: "Red and White Onion Flakes",
        category: "Dehydrated",
        description: "Mixed flakes of red and white dehydrated onions, perfect for soups, pizzas, and savory dishes.",
        hexCode: "25585DF53",
      },
       {
        id: "P007",
        image: require("../assets/red.jpeg"), // Suggested: coated onion rings close-up
        name: "Dehydrated Fried Coated Onions Red",
        category: "Dehydrated",
        description: "Deep-fried coated white onion slices with a crisp outer layer, perfect for snacks or toppings.",
        hexCode: "25585DF53",
      },
           {
        id: "P008",
        image: require("../assets/dwhite.jpeg"), // Suggested: crispy red & white fried onions in a bowl
        name: "Dehydrated Fried Onions White",
        category: "Dehydrated",
        description: "Crunchy, flavor-packed fried onions made from  white onion varieties, ideal for garnishing and seasoning.",
        hexCode: "25585DF53",
      },
    ]
  },
  "turmeric-powder": {
    title: "TURMERIC POWDER",
    image: herobg4,
    products: [
      {
        id: "P003",
        image: require("../assets/organic_turmeric_powder.png"), // Suggested: turmeric powder with root
        name: "Organic Turmeric Powder",
        category: "Turmeric",
        description: "High-quality turmeric powder rich in curcumin, known for its anti-inflammatory and antioxidant properties.",
        hexCode: "25585DF54",
      },
        {
        id: "P004",
        image: require("../assets/fingers.jpeg"), // Suggested: turmeric powder with root
        name: "Organic Turmeric Fingers",
        category: "Turmeric",
        description: "High-quality turmeric powder rich in curcumin, known for its anti-inflammatory and antioxidant properties.",
        hexCode: "25585DF54",
      },
    ]
  },
  "chilly-powder": {
    title: "CHILLY POWDER",
    image: herobg2,
    products: [
      {
        id: "P301",
        image: require("../assets/red_chilly_powder.png"), // Suggested: bowl of red chilli powder with dried chillies
        name: "Red Chilli Powder",
        category: "Chilly",
        description: "Spicy and bright red powder made from sun-dried red chillies, adds heat and color to any dish.",
        hexCode: "25585DF55",
      },
      {
        id: "P302",
        image: require("../assets/badgya_chilly.png"), // Suggested: Byadgi chillies next to their powder
        name: "Byadgi Mirchi Powder",
        category: "Chilly",
        description: "Mildly spicy, deep red powder made from Byadgi chillies, popular in Indian cuisine for its color and aroma.",
        hexCode: "25585DF55",
      },
      {
        id: "P303",
        image: require("../assets/garam_masala.png"), // Suggested: garam masala mix on a wooden board
        name: "Garam Masala",
        category: "Chilly",
        description: "A fragrant spice blend with chilli, cumin, coriander, and other Indian spices for rich flavor in curries.",
        hexCode: "25585DF55",
      },
      {
        id: "P304",
        image: require("../assets/dhaniya_powder.png"), // Suggested: coriander powder with coriander seeds
        name: "Dhaniya Powder",
        category: "Chilly",
        description: "Ground coriander powder with a citrusy aroma, commonly used in Indian and Middle Eastern dishes.",
        hexCode: "25585DF55",
      },
      {
        id: "P305",
        image: require("../assets/chilliPhoto.jpg"),
        name: "Teja Mirchi",
        category: "Chilly Powder",
        description:
          "Known for its high pungency and deep red color, Teja chillies are ideal for hot and spicy Indian dishes.",
        hexCode: "25585DF55",
      },
      {
        id: "P306",
        image: require("../assets/Byadgi.jpg"),
        name: "Byadgi Mirchi",
        category: "Chilly Powder",
        description:
          "Whole Byadgi chillies with rich red hue and mild heat, perfect for vibrant and aromatic masalas.",
        hexCode: "25585DF55",
      },
      {
        id: "P307",
        image: require("../assets/Kashmiri.jpg"),
        name: "Kashmiri Mirchi",
        category: "Chilly Powder",
        description:
          "Low on heat but rich in color, Kashmiri mirchi is widely used to impart a deep red color to gravies.",
        hexCode: "25585DF55",
      },
      {
        id: "P308",
        image: require("../assets/chilliPhoto1.jpg"),
        name: "Guntur Chilli",
        category: "Chilly Powder",
        description:
          "Famous for its intense spiciness, Guntur chillies are a staple in South Indian dishes and exports.",
        hexCode: "25585DF55",
      },
    ]
  }
};



const Categories = () => {
  const { category } = useParams();
  const currentCategory = categoryData[category] || categoryData["onion-products"];

  const [isQuotationModalOpen, setIsQuotationModalOpen] = useState(false);
  const [isProductDetailOpen, setIsProductDetailOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openQuotationModal = (product) => {
    setSelectedProduct(product);
    setIsQuotationModalOpen(true);
  };

  const closeQuotationModal = () => setIsQuotationModalOpen(false);

  const openProductDetail = (product) => {
    setSelectedProduct(product);
    setIsProductDetailOpen(true);
  };

  const closeProductDetail = () => setIsProductDetailOpen(false);

  return (
    <div className="min-h-screen bg-[#FBF1EB]">
      {/* Hero Section for Category */}
      <div className="relative w-full h-[50vh] min-h-[400px] overflow-hidden">
        <div className="relative w-full h-full">
          <img
            src={currentCategory.image}
            alt={currentCategory.title}
            className="object-cover w-full h-full"
          />
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="absolute left-8 bottom-8 z-20">
            <div className="bg-[#D9B58F] p-4 md:p-6 text-white border-r-8 border-[#B99063]">
              <h1 className="text-xl md:text-2xl font-bold text-[#000000]">SPECIALISED IN</h1>
              <h2 className="text-xl md:text-2xl font-bold text-[#000000]">
                {currentCategory.title}
              </h2>
            </div>
          </div>
        </div>
      </div>


      {/* Products Grid */}
      <section className="w-full py-12 px-4 md:px-8 bg-[#FBF1EB]">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl text-center font-bold text-[#73340E] mb-8">
            {currentCategory.title}
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {currentCategory.products.map((product) => (
              <div key={product.id} className="flex flex-col items-center">
                <div
                  className="w-full aspect-square relative mb-2 overflow-hidden cursor-pointer"
                  onClick={() => openProductDetail(product)}
                >
            <img
  src={product.image}
  alt={product.name}
  className="w-full h-[250px] object-cover rounded-md"
/>
                </div>
                <h3 className="text-lg font-medium text-[#34302B] mb-2 text-center">
                  {product.name}
                </h3>
                <Button
                  className="bg-[#73340E] hover:bg-[#C09670] text-white text-sm"
                  onClick={() => openQuotationModal(product)}
                >
                  Request Quotation
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modals */}
      <RequestQuotationModal
        isOpen={isQuotationModalOpen}
        onClose={closeQuotationModal}
        productName={selectedProduct?.name || ""}
        productId={selectedProduct?.id || ""}
      />

      {selectedProduct && (
        <ProductDetailPopup
          isOpen={isProductDetailOpen}
          onClose={closeProductDetail}
          onRequestQuotation={() => {
            closeProductDetail();
            openQuotationModal(selectedProduct);
          }}
          product={selectedProduct}
        />
      )}
    </div>
  );
};

export default Categories;